@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ExecutionResultMessages {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  border: 1px solid $theme-color-divider;
  border-radius: 4px;

  .Header {
    background-color: $theme-color-radio-disabled-background;
    padding: 7px 16px;
    border-bottom: 1px solid $theme-color-divider;
    font-weight: 600;
  }

  .BodyContent {
    @extend %font-log;

    background-color: $theme-test-config-log-message-background;
    padding: 16px;
    max-height: 200px;
    overflow: auto;
    line-height: 18px;
    color: $theme-filter-icon-color;
  }

  .LogEntry {
    display: flex;
    align-items: flex-start;
    column-gap: 16px;
  }

  .Timestamp {
    time {
      @extend %font-log;

      white-space: nowrap;
    }
  }

  .emergency,
  .alert,
  .critical,
  .error {
    color: $color-primary-red-hover;
    font-weight: $font-weight-semibold;
  }

  .warning {
    color: $color-warning-orange;
  }
}
